<app-spinner *ngIf="isSpinner" [isSpinning]="isSpinner"></app-spinner>

<div class="mock-page" *ngIf="!isSpinner">
  <header class="mock-intro">
    <h1>{{ 'mockTest' | translate }}</h1>
    <p>{{ 'mockIntro' | translate }}</p>
    <ul class="rules">
      <li>{{ 'mockRuleQuestions' | translate }}</li>
      <li>{{ 'mockRuleScoring' | translate }}</li>
      <li>{{ 'mockRuleFeedback' | translate }}</li>
    </ul>
  </header>

  <app-mock-subscription *ngIf="subscriptionRequired"></app-mock-subscription>

  <ng-container *ngIf="!subscriptionRequired">
  <section class="resume-card" *ngIf="resume">
    <div>
      <h2>{{ 'mockResumeTitle' | translate }}</h2>
      <p>{{ 'mockResumeBody' | translate }}</p>
      <p class="resume-meta">Paper {{ resume.paper }} · {{ resumeRemaining() }}</p>
    </div>
    <button type="button" class="primary-button" (click)="resumeExam()">
      {{ 'mockResume' | translate }}
    </button>
  </section>

  <section class="papers" aria-label="Papers">
    <div
      class="paper-card"
      role="button"
      tabindex="0"
      [class.selected]="selectedPaper === 'A'"
      (click)="selectPaper('A')"
      (keydown.enter)="selectPaper('A')"
      (keydown.space)="$event.preventDefault(); selectPaper('A')"
      [attr.aria-pressed]="selectedPaper === 'A'"
    >
      <span class="paper-kicker">{{ 'mockPaperA' | translate }}</span>
      <span class="paper-title">{{ 'mockPaperATitle' | translate }}</span>
      <ul>
        <li *ngFor="let key of topicKeysA">{{ key | translate }}</li>
      </ul>
    </div>
    <div
      class="paper-card"
      role="button"
      tabindex="0"
      [class.selected]="selectedPaper === 'B'"
      (click)="selectPaper('B')"
      (keydown.enter)="selectPaper('B')"
      (keydown.space)="$event.preventDefault(); selectPaper('B')"
      [attr.aria-pressed]="selectedPaper === 'B'"
    >
      <span class="paper-kicker">{{ 'mockPaperB' | translate }}</span>
      <span class="paper-title">{{ 'mockPaperBTitle' | translate }}</span>
      <ul>
        <li *ngFor="let key of topicKeysB">{{ key | translate }}</li>
      </ul>
    </div>
  </section>

  <section class="duration">
    <span class="duration-label">{{ 'mockDuration' | translate }}</span>
    <div class="duration-options">
      <button
        type="button"
        [class.selected]="duration === 120"
        (click)="selectDuration(120)"
        [attr.aria-pressed]="duration === 120"
      >
        {{ 'mockDurationPaper' | translate }}
      </button>
      <button
        type="button"
        [class.selected]="duration === 90"
        (click)="selectDuration(90)"
        [attr.aria-pressed]="duration === 90"
      >
        {{ 'mockDurationComputer' | translate }}
      </button>
    </div>
  </section>

  <p class="form-error" *ngIf="paperError">{{ 'mockSelectPaper' | translate }}</p>
  <p class="form-error" *ngIf="startError">{{ 'mockLoadError' | translate }}</p>

  <button type="button" class="primary-button start-button" [disabled]="starting" (click)="start()">
    {{ 'mockStart' | translate }}
  </button>

  <section class="shortfall" *ngIf="shortfalls.length">
    <h2>{{ 'mockShortfallTitle' | translate }}</h2>
    <p *ngFor="let note of shortfalls">{{ shortfallText(note) }}</p>
  </section>

  <section class="history">
    <h2>{{ 'mockHistory' | translate }}</h2>
    <p class="history-empty" *ngIf="!history.length">{{ 'mockHistoryEmpty' | translate }}</p>
    <div class="history-table" *ngIf="history.length">
      <nz-table nzTemplateMode>
        <thead>
          <tr>
            <th>Paper</th>
            <th>{{ 'mockSubmitted' | translate }}</th>
            <th>{{ 'mockScore' | translate }}</th>
            <th>{{ 'mockResultLink' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of history" class="history-row" (click)="openResult(item)">
            <td class="paper-cell">{{ item.paper }}</td>
            <td>{{ when(item.submitted_at) }}</td>
            <td>{{ scoreText(item) }} · {{ percentText(item.percentage) }}</td>
            <td>
              <a
                class="result-link"
                [class.passed]="item.passed"
                [class.failed]="!item.passed"
                [routerLink]="['/mock', item.id, 'result']"
                (click)="$event.stopPropagation()"
              >
                {{ (item.passed ? 'mockPassed' : 'mockFailed') | translate }}
              </a>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </section>
  </ng-container>
</div>
